module.exports = __webpack_public_path__ + "static/shoe-layer-1-effect-9127957f1917bd7c185650b42c3a0024.png";